import { Upload, type UploadFile } from 'antd'
import { message } from 'antd'
import { useEffect, useRef, useState } from 'react'

import { useAppSelector } from '@Store/hooks'

import FileUploaderBody from './FileUploaderBody'
import useBatchImportDispatch from '../../hooks/useBatchImportDispatch'

function FileUploader({
  uploadType,
  filenamePlaceholder = '',
  hintText = '',
}: {
  uploadType: 'apt' | 'upt' | 'upt-c'
  filenamePlaceholder?: string
  hintText?: string
}): JSX.Element {
  const { access_token } = useAppSelector((state) => state.auth)

  const [isLoading, setIsLoading] = useState(false)
  const [uploaderResponse, setUploaderResponse] = useState<any>(null)
  const file = useRef<UploadFile | null>(null)

  const { setMatchData, setUploadId } = useBatchImportDispatch()

  const onChangeUploadFile = (info: any) => {
    const { status, response, name: filename } = info.file

    file.current = info.file

    if (status === 'done' && response) {
      setIsLoading(false)
      setUploaderResponse(response)

      message.success(`${filename} file uploaded successfully.`)
    } else if (status === 'error') {
      setIsLoading(false)

      message.error(`${filename} file upload failed.`)
    } else if (status === 'removed') {
      setUploaderResponse(null)
      setIsLoading(false)
    } else {
      setIsLoading(true)
    }
  }

  useEffect(() => {
    if (uploaderResponse) {
      const { preview, upload_id } = uploaderResponse

      setMatchData(preview)
      setUploadId(upload_id)
    }
  }, [uploaderResponse])

  return (
    <Upload.Dragger
      name="file"
      multiple={false}
      accept=".xls,.xlsx"
      pastable
      maxCount={1}
      data={{
        upload_type: uploadType,
      }}
      method="POST"
      headers={{
        Authorization: `Bearer ${access_token}`,
      }}
      showUploadList={false}
      action={`${API_URL}/products/import/upload`}
      onChange={onChangeUploadFile}
      className="!m-0 !p-0 [&>.ant-upload]:!p-0 [&>.ant-upload]:!border-none [&>.ant-upload>.ant-upload-btn]:!p-0"
    >
      <FileUploaderBody
        isLoading={isLoading}
        isSuccess={!!uploaderResponse}
        filename={file.current?.name}
        filenamePlaceholder={filenamePlaceholder}
        hintText={hintText}
      />
    </Upload.Dragger>
  )
}

export default FileUploader
